/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ErrorByRoutePoint = zod
	.object({
		errors: zod.number().describe('Error count'),
		route_key: zod.string().describe('HTTP method and route pattern'),
		ts: zod.iso.datetime({ offset: true }).describe('Bucket timestamp')
	})
	.describe('Error count for a specific route at a time bucket');

export type ErrorByRoutePoint = zod.input<typeof ErrorByRoutePoint>;
export type ErrorByRoutePointOutput = zod.output<typeof ErrorByRoutePoint>;
